export const DEFAULT_GROUP_LIST_SIZE = 5;
